@if(isSetupModalOpen){
<app-device-setup (closeSignal)="closeWindow()" [deviceNumber]="selectedRow?.id!"></app-device-setup>
}
<div class="subpage-container">
  <div class="container g-0 m-0">
    <div class="row g-0 m-0 d-flex align-items-center">
      <div class="col-md-8 ps-5 pt-5 pb-4">
        <h2 class="col pb-2 title">
          {{ "TARIFFS_TITLE" | translate }}
        </h2>
        <h6 class="col subtitle">{{ "TARIFFS_SUBTITLE" | translate }}</h6>
      </div>
      <div class="col-md-4 d-flex justify-content-end gap-3 pe-5">
        @if (authService.isAuthorized([PermissionsEnum.Device_add])) {
        <button class="col-auto add justify-content-center text-nowrap" [routerLink]="['/tariff-setup']">
          {{ "TARIFFS_MENU_TARIFFSETUP" | translate }}
        </button>
        }
      </div>
    </div>
    <div class="row d-flex align-items-center g-0 m-0 p-0 mb-3">
      <div class="col-8 d-flex ustify-content-start ps-5 gap-3">
        <app-tariff-filter
          [numberOfResults]="numberOfDevices"
          [selectedCustomerTypes]="selectedFilters.customerTypes || []"
          [selectedTariffStatuses]="selectedFilters.tariffStatuses || []"
          [tariffNameSearch]="selectedFilters.tariffNameSearch || ''"
          (applied)="onTariffDataReceived($event)">
        </app-tariff-filter>
        <app-sort (close)="onSortOption($event)"></app-sort>
        <div class="datepicker-container-wrapper position-relative">
          <div class="button-wrapper">
            <div class="button">
              <img alt="Date" src="assets/core/table-button/date.svg" />
              <div class="button-text" (click)="toggleModal()"
                [ngClass]="{ changed: requestData.startDate && requestData.endDate }">
                <ng-container *ngIf="requestData.startDate && requestData.endDate; else noDateSelected">
                  {{ selectedDate }}
                </ng-container>
                <ng-template #noDateSelected>
                  <span class="nonselected-date">{{ "SELECTDATE" | translate }}</span>
                </ng-template>
              </div>
              <img *ngIf="requestData.startDate && requestData.endDate" alt="Exit" src="assets/device/x.svg"
                (click)="clearDates()" />
            </div>
          </div>
          @if (isDatepickerOpen) {
          <div class="overlay" (click)="toggleModal()"></div>
          <app-future-datepicker [scale]="1.1" [range]="true" (dateRangeChanged)="onDateRangeChanged($event)"
            [inputFromDate]="requestData.startDate" [inputToDate]="requestData.endDate"></app-future-datepicker>
          }
        </div>
        <app-search placeholder="{{ 'TARIFF_SEARCHBY' | translate }}"
          (searchChange)="searchChange($event)"></app-search>
      </div>

      <div class="col-4 d-flex justify-content-end align-items-center pe-5">
        <span *ngIf="selectedRows.length > 0" class="pe-3 custom-color">
          <img (click)="clear()" class="ps-1" alt="Unselect all" src="assets/device/clear.svg" />
          {{selectedRows.length}} Selected
        </span>
        <div *ngIf="selectedRows.length > 0 && authService.isAuthorized([PermissionsEnum.Device_bulk_delete])"
          class="button-wrapper-gray pe-2">
          <div class="button" (click)="isBulkDeleteModalOpen = true" title="Bulk delete">
            <img class="p-0" alt="Delete" src="assets/core/table/delete.svg" />
          </div>
        </div>

        <div *ngIf="selectedRows.length > 0 && authService.isAuthorized([PermissionsEnum.Device_bulk_configure])"
          class="button-wrapper-gray pe-2">
          <div class="button" (click)="isBulkSetupModalOpen = true" title="Bulk reconfiguration">
            <img *ngIf="selectedRows.length > 0" class="p-0" alt="Reconfig" src="assets/device/reconfig.svg" />
          </div>
        </div>
        <app-show-hide-columns></app-show-hide-columns>
      </div>
    </div>
    <div class="row g-0 m-0">
      <table>
        <thead>
          <tr>
            <th></th>
            <th class="ps-1">
              <input type="checkbox" [checked]="isAllSelected()" (change)="toggleAllSelected($event)"
                (click)="$event.stopPropagation()" class="form-check-input custom-checkbox" />
            </th>
            <ng-container *ngFor="let col of selectedColumns">
              <th>
                <div class="column-content">

                  <img src="assets/device/column-menu.svg" />
                  <span>{{ col.header | translate }}</span>
                </div>
              </th>
            </ng-container>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <!-- <tr *ngFor="let row of data" (click)="handleRowClick(row)">
            <td appIsNew [executedTime]="row.meterInstallationDate!" [seconds]="dayInMs"></td>
            <td class="ps-1">
              <input type="checkbox" [checked]="isRowSelected(row.id!)" [id]="'checkbox-' + row.id"
                (change)="toggleRowSelection(row.id!)" (click)="$event.stopPropagation()"
                class="form-check-input custom-checkbox" />
            </td>
            <ng-container *ngFor="let col of selectedColumns">
              <td>
                   <span
                  >
                  {{ col.key }}
                </span>
              </td>
            </ng-container>

            @if (authService.isAuthorized([PermissionsEnum.Device_delete])) {
            <td>
              <img class="p-0" alt="Delete" src="assets/core/table/delete.svg" (click)="handleEdit(row)" />
            </td>
            }
            @if (authService.isAuthorized([PermissionsEnum.Device_delete])) {
            <td>
              <img class="p-0" alt="Delete" src="assets/core/table/delete.svg" (click)="handleDelete(row)" />
            </td>
            }
          </tr> -->
        </tbody>
      </table>
    </div>
  </div>
</div>

<app-confirm-dialog *ngIf="isDeleteModalOpen" titleKey="DELETE" question="TARIFFS_DELETE"
  (confirm)="confirmDelete(selectedRow!)" (cancel)="cancelDelete()"></app-confirm-dialog>

<app-confirm-dialog *ngIf="isBulkDeleteModalOpen" titleKey="BULK_DELETE" question="DEVICES_BULKDELETE"
  (confirm)="confirmBulkDelete()" (cancel)="isBulkDeleteModalOpen = false"></app-confirm-dialog>

<app-confirm-dialog *ngIf="isBulkSetupModalOpen" titleKey="SETUP" question="DEVICES_BULKSETUP"
  (confirm)="bulkSetup()" (cancel)="isBulkSetupModalOpen = false"></app-confirm-dialog>

<div class="container-down">
  <app-pagination [lastPageSize]="lastPageSize" [numberOfDevices]="numberOfDevices" [pageSize]="pageSize"
    [currentPage]="currentPage" (pageChange)="pageChange($event)"></app-pagination>
</div>

<router-outlet></router-outlet>